import React, { Component } from 'react';
import './Dashboard.css';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link,Redirect } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import DashboardBar from '../../../components/Recruiter/DashboardBar/DashboardBar';
import { connect } from 'react-redux';
import config from '../../../config';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Recruiter Dashboard
* @version 0.1.0
* @author Jamshith,Praveen George
*/
class Dashboard extends Component {

  componentDidMount(){
    window.scrollTo(0,0);
    if(localStorage.getItem('interviewId') && localStorage.getItem('interviewId')!== "" && localStorage.getItem('interviewId')!== "null") {
      this.props.history.push({
        pathname: '/recruiter/interview',
        state:{clientId: localStorage.getItem('interviewId')}
      });
      localStorage.removeItem('interviewId');
      <Redirect exact to="/recruiter/account"/>
      //this.handleJobSelected(localStorage.getItem('interviewId'));    
    }
  }
  
  render() {
    // ConsoleLog("dash",this.props.interviewListCount.count)
    return (
      <div>
      	<div className="dashboard">
          <Row className="dashboard-row pg-dashboard-row">
            <div className="dashboard-links">
              <Col xs={12} sm={4}>
                <Link to="/recruiter/pool-import" className="link link-add-new-job">
                  <span>Add New Job</span></Link>
              </Col>
              <Col xs={12} sm={4}>
                <Link to="/recruiter/pool-view-all" className="link link-view-all-jobs">
                  <span>View All Jobs</span></Link>              
              </Col>
              <Col xs={12} sm={4}>
                <Link to="/recruiter/recruiter-all-reports" className="link link-recruiter-reports">
                  <span>Reports</span></Link>
              </Col>
              {/* <Col xs={12} sm={3}>
                <Link to="/recruiter/interview-scheduler" 
                  className="link link-recruiter-schedular">
                  <span>Interviews</span>
                </Link>
              </Col> */}
            </div>
          </Row>
      	</div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  interviewListCount: state.clientProfile.interviewListCount,
  user: state.cognito.user
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/container/Recruiter/Dashboard/Dashboard.js